<section class="flex min-h-[320px] flex-col">
  <div
    class="flex flex-1 flex-col justify-start"
    [ngClass]="{'items-center pt-4': modulesForm.length === 0}"
  >
    @if (modulesForm.length === 0) {
      <button
        type="button"
        lButton
        [bType]="buttonTypeEnum.PRIMARY"
        [bSize]="buttonSizeEnum.MEDIUM"
        [bRadius]="buttonRadiusEnum.LARGE"
        class="inline-flex items-center gap-2"
        (click)="onAddModule()"
      >
        Adicionar módulo
        <l-icon class="text-lg">add</l-icon>
      </button>
    } @else {
      <ul
        cdkDropList
        class="drag-sort-list mb-6 m-0 flex list-none flex-col gap-3 p-0"
        [cdkDropListData]="modulesForm.controls"
        aria-label="Lista de módulos"
        (cdkDropListDropped)="onModulesReordered($event)"
        (cdkDropListSorted)="onListSorted($event)"
      >
        @for (moduleForm of modulesForm.controls; track moduleForm.controls.id.value) {
          <li
            cdkDrag
            cdkDragLockAxis="y"
            class="drag-sort-item block w-full"
            [cdkDragData]="moduleForm"
            (cdkDragStarted)="onDragStartedForModule(moduleForm.controls.id.value)"
            (cdkDragEnded)="onDragEnded()"
          >
            <l-course-module-card
              [class.sr-only]="isDraggingModule(moduleForm.controls.id.value)"
              [moduleIndex]="getDisplayIndex(moduleForm.controls.id.value)"
              [name]="moduleForm.controls.name.value"
              [showActivationToggle]="isUpdate"
              [isActive]="isModuleActive(moduleForm)"
              (nameChange)="onModuleNameChange(moduleForm.controls.id.value, $event)"
              (isActiveChange)="onModuleActiveChange(moduleForm.controls.id.value, $event)"
              (delete)="onDeleteModule(moduleForm.controls.id.value)"
            />

            <ng-template cdkDragPlaceholder>
              <l-course-module-card
                class="module-card--ghost block w-full"
                [ghost]="true"
                [moduleIndex]="getDisplayIndex(moduleForm.controls.id.value)"
                [name]="moduleForm.controls.name.value"
              />
            </ng-template>

            <ng-template cdkDragPreview matchSize>
              <l-course-module-card
                class="block w-full"
                [preview]="true"
                [moduleIndex]="getDisplayIndex(moduleForm.controls.id.value)"
                [name]="moduleForm.controls.name.value"
              />
            </ng-template>
          </li>
        }
      </ul>

      <div class="flex justify-center">
        <button
          type="button"
          lButton
          [bType]="buttonTypeEnum.PRIMARY"
          [bSize]="buttonSizeEnum.MEDIUM"
          [bRadius]="buttonRadiusEnum.LARGE"
          class="inline-flex items-center gap-2"
          (click)="onAddModule()"
        >
          Adicionar módulo
          <l-icon class="text-lg">add</l-icon>
        </button>
      </div>
    }
  </div>
</section>
